import axios from "../plugins/axios";

// 全部统计数据
export const apiStatisticsAll = async (params) => {
    const res = await axios.get("/statistics/all", {params});
    if (res.data.code === 200) {
        return Promise.resolve(res.data.data);
    } else {
        return Promise.reject(res.data.msg);
    }
};

// 日统计
export const apiStatisticsDayCount = async (params) => {
    const res = await axios.get("/statistics/dayCount", {params});
    if (res.data.code === 200) {
        return Promise.resolve(res.data.data);
    } else {
        return Promise.reject(res.data.msg);
    }
};

// 月统计
export const apiStatisticsMonthCount = async (params) => {
    const res = await axios.get("/statistics/monthCount", {params});
    if (res.data.code === 200) {
        return Promise.resolve(res.data.data);
    } else {
        return Promise.reject(res.data.msg);
    }
};

// 全部统计2
export const apiStatisticsAll2 = async (params) => {
    const res = await axios.get("/statistics/dailyStatisticsPage", {params});
    if (res.data.code === 200) {
        return Promise.resolve(res.data.data);
    } else {
        return Promise.reject(res.data.msg);
    }
}

// 计算实际消耗量及补充电量
export const apiCalculateActualConsumptionAndRecharge = async (params) => {
    const res = await axios.get("/statistics/calculateActualConsumptionAndRecharge", {params});
    if (res.data.code === 200) {
        return Promise.resolve(res.data.data);
    } else {
        return Promise.reject(res.data.msg);
    }
}
